import type * as Api from 'Api'

export const newsErrorHandbook: Api.ErrorsHandbook<'default'> = {
  default: [],
}
